import React, { useCallback, useEffect, useState } from 'react';
import { api } from './api';
import { toast } from '../hooks/use-toast';
import { errorMessage } from './errors';
import { formatDateTime } from './kit/time';
import { CalendarClock } from 'lucide-react';

const LABEL = { scheduled: 'Scheduled', sending: 'Sending', sent: 'Sent', failed: 'Failed', cancelled: 'Cancelled' };

const outcome = (r) => {
  if (r.status === 'sent' && r.result) {
    const { sent = 0, blocked = 0, failed = 0 } = r.result;
    return [`${sent} sent`, blocked && `${blocked} skipped`, failed && `${failed} failed`].filter(Boolean).join(', ');
  }
  return r.status === 'failed' ? r.error || '' : '';
};

// Ticket 208: the emails waiting to go out (and how the last few went), with Cancel.
export default function ScheduledEmails({ refreshKey }) {
  const [rows, setRows] = useState([]);

  const load = useCallback(async () => {
    try { const { data } = await api.get('/email/scheduled'); setRows(data || []); } catch { setRows([]); }
  }, []);
  useEffect(() => { load(); }, [load, refreshKey]);

  const cancel = async (id) => {
    try {
      await api.post(`/email/scheduled/${id}/cancel`);
      toast({ title: 'Send cancelled' });
    } catch (e) {
      toast({ title: 'Could not cancel', description: errorMessage(e, 'It may already have gone out') });
    }
    load();
  };

  if (!rows.length) return null;
  return (
    <div className="mt-8" data-testid="scheduled-emails">
      <h2 className="font-serif text-xl font-semibold mb-3 flex items-center gap-2" style={{ color: '#070B5F' }}><CalendarClock size={18} /> Scheduled emails</h2>
      <div className="space-y-2">
        {rows.map((r) => (
          <div key={r.scheduled_id} className="flex items-center justify-between gap-3 p-3 bg-white rounded-xl border border-slate-100">
            <div className="min-w-0">
              <div className="text-sm font-semibold truncate" style={{ color: '#070B5F' }}>{r.subject}</div>
              <div className="text-xs text-slate-500">
                {LABEL[r.status] || r.status} · {formatDateTime(r.send_at)} · {r.recipient_count} {r.recipient_count === 1 ? 'recipient' : 'recipients'}
                {outcome(r) ? ` · ${outcome(r)}` : ''}
              </div>
            </div>
            {r.status === 'scheduled' && (
              <button type="button" onClick={() => cancel(r.scheduled_id)} className="text-xs font-semibold text-red-600 hover:underline" data-testid={`cancel-${r.scheduled_id}`}>Cancel</button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
